<template>
  <div>
    <rl :rd="routerData"></rl>
    <div class="container" id="certify">
      <swiper
        class="banner"
        v-if="datas.length"
        ref="bannerSwiper"
        :options="swiperOptions"
        @ready="handleSwiperReadied($event)"
      >
        <swiper-slide v-for="(v, k) in datas" :key="k" >
          <!-- <a :href="v.link" v-if="v.link&&v.link.startsWith('http')" target="_blank"><img :src="screenWidth>750?(v.img+'?x-oss-process=image/resize,w_'+screenWidth+',m_lfit'):(v.img2+'?x-oss-process=image/resize,w_'+screenWidth+',m_lfit')" alt="" /></a> -->
          <a ><img :src="screenWidth>750?(v.img+'?x-oss-process=image/resize,w_'+screenWidth+',m_lfit'):(v.img2+'?x-oss-process=image/resize,w_'+screenWidth+',m_lfit')" alt="" /></a>
          <!-- <a  v-if="!v.link"  ><img :src="screenWidth>750?(v.img+'?x-oss-process=image/resize,w_'+screenWidth+',m_lfit'):(v.img2+'?x-oss-process=image/resize,w_'+screenWidth+',m_lfit')" alt="" /></a>
v-if="v.link&&!v.link.startsWith('http')" target="_blank"
          {{v.link}} -->
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>
  </div>
</template>
<script>
var WW =  document.body.clientWidth;
import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";
// import Swiper from "swiper";
import routerLink from "../public/routerlink.vue";
import { log } from "util";
export default {
  name: "app",
  components: {
    Swiper,
    SwiperSlide,
    directive,
    rl: routerLink,
  },
  data() {
    var vue = this;
    return {
      routerData: [{ title: "精品课程", link: "vbanner" }],
      screenWidth: document.body.clientWidth,
      datas: [],
      page: {
        total: 0,
      },
      get: {
        key: "videobanner",
      },
      swiper: "",
      swiperOptions: {
        watchSlidesProgress: true,
        slidesPerView: "auto",
        centeredSlides: true,
        loop: true,
        loopedSlides: 5,
        autoplay: false,
        observer: true,
        observeParents: true,
        observeSlideChildren: true,
        pagination:{
           el: '.swiper-pagination'
        },
        
        on: { click: function (swiper, event) {
            // console.log(this.realIndex,vue.datas);/
            if(vue.datas[this.realIndex]&&vue.datas[this.realIndex]['link']){
              var link =vue.datas[this.realIndex]['link'];
              if(link.startsWith('http')){
                window.location.href = link;
              }else{
                vue.$router.push(link);
              }
            }
            return ;
            
        },
          progress: function (progress) {
            var width = this.width / 3.3;
            for (var i = 0; i < this.slides.length; i++) {
              var slide = this.slides.eq(i);
              var slideProgress = this.slides[i].progress;
              if (Math.abs(slideProgress) > 1) {
                var modify = (Math.abs(slideProgress) - 1) * 0.3 + 1;
              }
              var translate = slideProgress * modify * width + "px";
              var scale = 1 - Math.abs(slideProgress) / 5;
              var zIndex = 999 - Math.abs(Math.round(10 * slideProgress));
              slide.transform(
                "translateX(" + translate + ") scale(" + scale + ")"
              );
              slide.css("zIndex", zIndex);
              slide.css("opacity", 1);
              if (Math.abs(slideProgress) > 3) {
                slide.css("opacity", 0);
              }
            }
          },
          setTransition: function (transition) {
            for (var i = 0; i < this.slides.length; i++) {
              var slide = this.slides.eq(i);
              slide.transition(transition);
            }
          },
        },
      },
    };
  },
  created() {
    this.getData();
  },
  methods: {
    pageChange($event) {
      this.get.pi = $event;
      this.$router.push({ name: "video", params: { p: $event } });
    },
    
    getData() {
      this.$http.get("/Index/Config/data", { params: this.get }).then((res) => {
         this.datas = res.value.banner.reduce((pre, cur) => {
          if (cur.show) {
            return pre.concat(cur);
          } else {
            return pre;
          }
        }, []);
      });
    },
    go($data) {
      // console.log($data);
      this.$router.push($data);
    },
    handleSwiperReadied(swiper) {
      this.swiper = swiper;
    },
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        //this.swiper.update(this.swiperOptions)
        // var certifySwiper = new Swiper(
        //   "#certify .swiper-container",
        //   this.swiperOptions
        // );
      }, 2000);
    });
  },
};
</script>
<style lang="less" scoped>
#certify .swiper-container {
  /* width: 70%; */
  width: 100%;
  padding-bottom: 60px;
 
}

#certify .swiper-slide {
  width: 60%;
  /*	height: 408px;
  height: 408px; */
  background: none;
  /* box-shadow: 0 8px 30px #ddd; */
}
#certify .swiper-slide img {
  display: block;
  width: 100%;
  border-radius: 8px;
}
#certify .swiper-slide p {
  line-height: 98px;
  padding-top: 0;
  text-align: center;
  color: #636363;
  font-size: 1.1em;
  margin: 0;
}

#certify .swiper-pagination {
  width: 100%;
  bottom: 20px;
}

#certify .swiper-pagination-bullets .swiper-pagination-bullet {
  margin: 0 5px;
  border: 3px solid #fff;
  background-color: #d5d5d5;
  width: 10px;
  height: 10px;
  opacity: 1;
}

#certify .swiper-pagination-bullets .swiper-pagination-bullet-active {
  border: 3px solid #00aadc;
  background-color: #fff;
}

#certify .swiper-button-prev:hover {
  background-position: 0 -46px;
  background-size: 100%;
}

#certify .swiper-button-next:hover {
  background-position: 0 -139px;
  background-size: 100%;
}
.max {
  max-width: 100%;
}
.page {
  margin: 10px auto;
  text-align: center;
}
.video-list {
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  // justify-content: space-between;
  padding: 0;
}
h3 {
  font-size: 20px;
  margin: 10px 0;
  font-weight: 500;
  color: rgba(124, 124, 124, 1);
  opacity: 1;
  padding-bottom: 10px;
  display: flex;
  align-items: top;
  border-bottom: 1px dotted #bfbfbf;
  span {
    flex: 1 0 24px;
  }
}
.flexbox {
  overflow: hidden;
  box-sizing: border-box;
  width: 33.33%;
  padding: 10px;
  flex-flow: column;
  align-items: stretch;
  .showbox {
    height: 100%;
    position: relative;
    padding-bottom: 30px;
    .rel {
      position: relative;
    }
    .square {
      width: 100%;
      height: 0;
      padding-bottom: 100%;
    }
    .abs {
      position: absolute;
      height: 100%;
      width: 100%;
      top: 0;
      left: 0;

      p {
        margin-top: 10px;
      }
    }
    border: 1px solid #bfbfbf;
    box-sizing: border-box;
    padding: 30px;
    &:hover {
      border: 1px solid #ef504f;
    }
  }
}

div.time {
  position: absolute;
  bottom: 0;
  width: 100%;
  text-align: right;
  display: flex;
  justify-content: space-between;
  align-items: center;
  left: 0;
  padding: 0 30px;
  bottom: 10px;
  img {
    float: left;
    height: 12px;
    width: 12px;
  }
}
.titleImg {
  margin-right: 20px;
  width: 12px;
  height: 12px;
}
@media (min-width:765px) {

    #certify .swiper-container{
    margin-top:55px;
   margin-bottom:105px;
  }
}

@media (max-width: 1199px) {
  .flexbox {
    width: 50%;
    padding: 20px;
    .showbox {
      border: 1px solid #bfbfbf;
      box-sizing: border-box;
      padding: 30px;
    }
  }
}
@media (max-width: 750px) {

  
  .titleImg {
    width: 12px;
    height: 12px;
    margin-right: 5px;
  }
  div.time {
    // position: relative;
    bottom: 10px;
    font-size: 10px;
    padding: 0 10px;
    white-space: nowrap;
    margin-top: 10px;
    span {
      display: none;
    }
  }
  .flexbox {
    padding: 5px;
    .showbox {
      height: 100%;
      padding: 10px;
      padding-bottom: 40px;
      align-content: stretch;
      .square {
        padding-bottom: 0;
      }
      .abs {
        height: 100%;
        position: relative;
        p {
          font-size: 10px;
        }
      }
    }
  }
  h3 {
    font-size: 12px;
    line-height: 18px;
    padding-bottom: 10px;

    img {
      margin-top: 3px;
    }
  }
}
</style>